import React from 'react';
import { Flame, TrendingUp, Minus, Moon } from 'lucide-react';

const ERS_CONFIG = {
  hot:     { color: 'bg-red-100 text-red-800 border-red-300',       icon: Flame,      label: 'HOT' },
  warm:    { color: 'bg-orange-100 text-orange-800 border-orange-300', icon: TrendingUp, label: 'WARM' },
  cold:    { color: 'bg-blue-100 text-blue-800 border-blue-300',    icon: Minus,      label: 'COLD' },
  dormant: { color: 'bg-gray-100 text-gray-500 border-gray-300',    icon: Moon,       label: 'DORMANT' },
};

export function ERSBadge({ score, band, showScore = true }) {
  const config = ERS_CONFIG[band] || ERS_CONFIG.dormant;
  const Icon = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${config.color}`}>
      <Icon className="w-3 h-3" />
      {config.label}
      {showScore && score !== undefined && <span className="opacity-60">({score})</span>}
    </span>
  );
}

export function FreshnessIndicator({ lastResearchedAt }) {
  if (!lastResearchedAt) return <span className="text-xs text-gray-400">Never researched</span>;

  const days = Math.floor((Date.now() - new Date(lastResearchedAt).getTime()) / (1000 * 60 * 60 * 24));
  let emoji, label, color;
  if (days <= 7)       { emoji = '🟢'; label = 'Fresh';    color = 'text-green-600'; }
  else if (days <= 30) { emoji = '🟡'; label = 'Aging';    color = 'text-yellow-600'; }
  else if (days <= 60) { emoji = '🟠'; label = 'Stale';    color = 'text-orange-600'; }
  else                 { emoji = '🔴'; label = 'Outdated'; color = 'text-red-600'; }

  return (
    <span className={`text-xs font-medium ${color}`}>
      {emoji} {label} <span className="text-gray-400 font-normal">({days}d ago)</span>
    </span>
  );
}
